<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search_form"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50, 100],
      }"
      :items-per-page="20"
      class="elevation-1"
      single-expand
      :expanded.sync="expanded"
      show-expand
    >
      <template v-slot:top>
        <v-layout class="pa-3">
          <v-text-field
            v-model="search_form"
            label="Vyhľadať"
          />
        </v-layout>
      </template>

      <template v-slot:item.created_at="{ item }">
        {{ item.created_at | moment("DD.MM.YYYY HH:mm") }}
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <span>Pracovné zručnosti: {{ item.pracovne_zrucnosti }}</span>
          <v-divider />
          <span>Ponuka: {{ item.ponuka }}</span>
        </td>
      </template>

      <template v-slot:item.pracovne_zaradeny="{ item }">
        <span v-if="item.pracovne_zaradeny">Áno</span>
        <span v-else>Nie</span>
      </template>
    </v-data-table>
  </div>
</template>
<script>

import { APIService } from "@/http/APIService.js";
import Vue from "vue";

const apiService = new APIService();
Vue.use(require("vue-moment"));

export default {
  name: "SocialnyPodnikTable",
  props: {
    items: { required: true, type: Array }
  },

  data() {
    return {
      timeout: null,

      dialog: false,
      selectedItem: null,
      search_form: "",

      loading: true,
      options: {},
      expanded: [],

      headers: [
        {
          text: "Dátum vytvorenia",
          value: "created_at",
        },
        { text: "Vek", value: "prisoner.age_1" },

        { text: "Okres", value: "prisoner.trvale_bydlisko_okres" },

        {
          text: "Najvyššie dosiahnuté vzdelanie",
          value: "prisoner.najvyssie_dosiahnute_vzdelanie",
        },
        { text: "Pôvodné povolanie", value: "prisoner.povodne_povolanie" },
        { text: "Dátum možného nástupu", value: "prisoner.nastup" },
        { text: "Typ dôchodcu", value: "prisoner.typ_dochodcu" },
        { text: "Stav", value: "status" },
      ],
    };
  },

  methods: {
  }
};
</script>
    
